export function initHomeSlider($) {
	if(document.home_slides) {
		let slides = document.home_slides;
		// pick a random slide
		const random = Math.floor(Math.random() * slides.length);

		populateSlide($, slides[random]);
	}
}

function populateSlide($, slide) {
	$('#home-heading').html(slide.heading);
	$('#home-subheading').html(slide.subheading);
	$('#home-paragraph').html(slide.paragraph);
	$("#home-header").addClass(slide.header_position);
	$('#home-header').css("background-image", "url(" + slide.image + ")");
}

export function initSlider($) {
	$('.slider:not(.slider-block)').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 10000,
			navText: [
                '<i class="slider-fa-control fal fa-chevron-left"></i>',
                '<i class="slider-fa-control fal fa-chevron-right"></i>'
            ],
			navElement: 'div',
			animateIn: 'fadeIn',
			animateOut: 'fadeOut',
		});
	});

	$('.slider.slider-block').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: true,
			autoplay: true,
			autoplayTimeout: 7000,
			smartSpeed: 7000,

			animateIn: 'fadeIn',
			animateOut: 'fadeOut',
		});
	});

	$('.slider2.slider2preview').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: true,
			dots: false,
			autoplay: false,
			autoplayTimeout: 7000,
			navText: [
				'<i class="fal fa-circle-arrow-left"></i>',
				'<i class="fal fa-circle-arrow-right"></i>'
			],
			navElement: 'div',
			responsive:{
				0:{
					stagePadding:0
				},
				1200:{
					stagePadding: 100,
					margin: 30
				}
			}
		});
	});

	$('.slider2.slider2normal').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 7000,
			navText: [
				'<i class="fal fa-circle-arrow-left"></i>',
				'<i class="fal fa-circle-arrow-right"></i>'
			],
			navElement: 'div'
		});
	});

}